import Footer from '@fragments/Setting/Footer';
import Header from '@fragments/Setting/Header';
import { type FC } from 'react';
import Content from './Content';
import { Container } from './style';

const IntervieweeSettingPage: FC = () => {
  return (
    <Container>
      <Header />
      <Content />
      <Footer />
    </Container>
  );
};

export default IntervieweeSettingPage;
